import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { usePayrollStore } from '@/stores/payroll';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollGageAlertDialog',
  setup(__props) {

    const { t } = useI18n();

    const payrollStore = usePayrollStore();

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { salary: number }) =>
            axios.post(
                route('v2.salary.employee.update', { id: payrollStore.employeeId }),
                formData,
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('companies.save_success'));
            payrollStore.clearData();
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

    function update() {
        mutate({
            salary: payrollStore.value,
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), {
    open: _unref(payrollStore).gageModalOpen,
    "onUpdate:open": _cache[0] || (_cache[0] = (value) => _unref(payrollStore).toggleModal('gage', value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.modal.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.modal.body_1')) + " ", 1),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(payrollStore).employeeName), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('payrolls.edit.modal.body_2')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.modal.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                disabled: _unref(isPending),
                onClick: update
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.modal.confirm')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})